import _ from "lodash";
import { stringify } from "query-string";
import { prestigeContentDefaultData } from "./prestige";
import { VIP_TIER } from "../Foundation";
import Utils from "../Utils";
import StorageHelper from "../StorageHelper";
import { LOCAL_STORAGE_KEY } from "../Foundation";
import axios from "axios";

const URL_ASSETS = "/cms/assets";

const DEFAULT_IMAGE_CONFIG = {
  format: "webp",
  width: "",
  height: "",
  quality: "",
  fit: "",
  crop: "",
  gravity: "",
  withoutEnlargement: "",
  background: "",
};

class DirectusUtil {
  static getTrans(item, key) {
    key = key || "name";
    const defaultName = _.get(prestigeContentDefaultData, item.name, item.name);
    return _.get(item, `translations[0].${key}`, defaultName);
  }
  static getTitle(item) {
    return DirectusUtil.getTrans(item, "title");
  }

  static getText(item) {
    return DirectusUtil.getTrans(item, "text");
  }

  static getImage(id, config) {
    config = _.pickBy(_.assign({}, DEFAULT_IMAGE_CONFIG, config), value => value !== "");
    const params = stringify(config, { addQueryPrefix: true });
    const rawUrl = URL_ASSETS + "/" + id + params;
    return Utils.cleanUrlParams(rawUrl);
  }

  static getValueWithName(item, name) {
    return _.find(item, { name: name }) || {};
  }

  static getTextWithName(item, name) {
    const value = DirectusUtil.getValueWithName(item, name);
    return DirectusUtil.getText(value);
  }

  static transformBenefits(dataBenefits) {
    const groupedBenefits = _.groupBy(dataBenefits, (benefit) => {
      const match = benefit.name.match(/benefits_(\d+)(?:-(\d+))?/);
      return match ? `benefits_${match[1]}` : benefit.name;
    });

    return _.map(groupedBenefits, (benefits, key) => {
      const parentBenefit = _.find(benefits, (b) => !b.name.includes("-"));
      const subDescriptions = _.filter(benefits, (b) => b.name.includes("-"));

      if (parentBenefit) {
        return {
          ...parentBenefit,
          sub_description: subDescriptions,
        };
      }

      return benefits[0];
    });
  }

  static isClaimable(benefitName) {
    const rankRegex =
      /prestige\.\[(silver|gold|diamond|platinum)\]\.benefits_\d+/;
    return rankRegex.test(benefitName);
  }

  static renderClaim(benefitName, view = () => {}) {
    const path = `/${Utils.getCurrentLang()}/${Utils.getCurrentView()}/promotion`;

    return DirectusUtil.isClaimable(benefitName) ? view(path) : null;
  }

  static getTier() {
    const currentTierId = _.get(Utils.getUdata(), "currentTierId");
    return _.get(VIP_TIER, currentTierId, _.values(VIP_TIER)[0]);
  }

  static async getBrandInfoFromDirectus(brandCode) {
    const xAppData = StorageHelper.convertStringToJSON(localStorage.getItem(LOCAL_STORAGE_KEY.APP_DATA));
    const directusToken = xAppData.directusToken
    const api = axios.create({
      baseURL: "/cms",
      headers: {
        "Authorization": `Bearer ${directusToken}`,
        "Content-Type": "application/json"
      }
    });
    try {
      const response = await api.post("/graphql", {
        query: `query {
                brand_info (
                  filter: { 
                    status: { _eq: "published" }
                    _or: [
                      { brand_code: { _eq: "${brandCode}" } }
                    ]
                  }
                ) {
                  id
                  brand_name
                  brand_code
                  brand_alias
                }
              }`
      });
      return response.data.data.brand_info;
    } catch (error) {
      console.error("Error:", error.response.data || error.message);
    }
  }
  
}

export default DirectusUtil;




// WEBPACK FOOTER //
// ./src/app/common/directus/ultis.js